(function( $ ){

	var mediaViewer = function() {
		
		var me = this;
		var el, $el;
		
		this.settings = {
			urlGet: '/api/media/:id',
			urlEdit: '/api/media/:id/edit',
			urlPut: '/api/media/:id',
			onInit: null,
			onEdit: null,
			onUpdate: null,
			save: true,
			values: {

			},
			fancybox: {
				width: '95%',
				height: '95%',
				autoSize: false,
				padding: 0,
				wrapCSS: 'fancybox-mediaviewer'
			},
		}
		
		this.init = function( options ) 
		{
			$.extend(true, me.settings, options, $(this).data());
			me.el = this;
			me.$el = $(this);
			
			me.$el.on('click', me.edit);

			if(me.settings.onInit instanceof Function) me.settings.onInit.call(me);
		}

		/**
		 *	Open the mediaviewer
		 *
		 *	@param  Event e
		 *	@return void
		 */
		this.edit = function( e )
		{
			e.preventDefault();

			var mediaItemId = $(this).data('id'),
				link = $(this);

			var params = [];
			for(var i in me.settings.values)
			{
				params.push(encodeURIComponent(i) + '=' + encodeURIComponent(me.settings.values[i]));
			}
			if(params.length) params = '?' + params.join('&');

			$.fancybox($.extend(true, 
			{
				type: 'ajax',
				href: me.settings.urlEdit.replace(':id', mediaItemId) + params,
				helpers: {
					overlay: {
						locked: false
					}
				},
				afterShow: function()
				{
					me.$lightbox = $(this.inner);

					me.$lightbox.find('[data-rel="rotate"]').click(function(e)
					{
						e.preventDefault();

						var rotate = parseInt(me.$lightbox.find(':input[name="rotate"]').val());
						rotate += 90;
						if(rotate == 360) rotate = 0;
						me.$lightbox.find(':input[name="rotate"]').val(rotate);

						me.$lightbox.find('.item img').css({
							'transform': 'rotate(' + rotate + 'deg)'
						});
					});

					me.$lightbox.find('form').submit(function(e)
					{
						e.preventDefault();

						$form = $(this);

						// Determine if the data needs to be saved or just simply returned
						var ajaxSettings = {
							dataType: 'json',
							success: function( mediaItem )
							{
								if(!me.settings.save)
								{
									var values = $form.serializeArray();
									for(var i in values)
									{
										mediaItem[values[i].name] = values[i].value;
									}
								}
								
								if(me.settings.onUpdate instanceof Function) me.settings.onUpdate.call(me, mediaItem);

								if(link)
								{
									var src = link.find('img').attr('src');
									
									if(src.indexOf('?') == -1)
										src += '?refresh=1';

									src += '&v=1';

									link.find('img')
										.attr('src', '')
										.attr('src', src);
								}

								$.fancybox.close();
							}
						};
						if(me.settings.save)
						{
							ajaxSettings.method = $form.attr('method');
							ajaxSettings.url = $form.attr('action');
							ajaxSettings.data = $form.serialize();
						}
						else
						{
							ajaxSettings.method = 'GET';
							ajaxSettings.url = me.settings.urlGet.replace(':id', mediaItemId);
						}

						$.ajax(ajaxSettings);
					});

					if(me.settings.onEdit instanceof Function) me.settings.onEdit.call(me);
				}
			}, me.settings.fancybox));
		}
	}
	
	$.fn.mediaviewer = function( options ) 
	{
		return this.each(function() 
		{
			var element = $(this);
			var newmediaviewer = new mediaViewer();
			newmediaviewer.init.call(this, options);
		});
	};

})( jQuery );